import React ,{useState, useEffect  }from 'react'
import Button from 'components/Button'
import {
  StyledDrawer,
  FooterFlex,
  DetailHeader,
  RightText,
} from 'modules/Roles/Style/style'
import { formatNumber } from 'utils/formatNumber'
import Control from 'components/Control/Control'
import { Form } from 'antd'
import {
  StyledSelectDiv,
  StyledInputDiv,
  TierInputNumber,
} from 'modules/ManageProfile/Style/style'
import AntdSelect from 'components/Form/Select'
import { OfferNegotiate }  from 'modules/OfferLetter/actions'
import { useDispatch,useSelector } from 'react-redux'
import { getAppliedRoleMetrics } from '../../Applied_Roles/actions'


const NegotiateOfferDrawer = ({
  drawer,
  setDrawer,
  selectedoffer,
  setDrawerNegotiate,
  setDrawerSuccess,
  OfferAcceptReject,
  onPageChange,
  setFilter,
  updateDataCall,
  offerNegotiateTemplate,
  getUserCorpList,
  sendNotificationBulkEmail
  
}) => {
  const dispatch = useDispatch()
  let stdData = useSelector(state => state?.studentData?.studentDetails)
  const [corporateEmailList, setCorporateEmailList] = useState([])

  useEffect(() => {
    ;(async () => {
      if (selectedoffer?.role?.corporate?.id) {
        let responce = await getUserCorpList(selectedoffer?.role?.corporate?.id)
        setCorporateEmailList(responce)
      }
    })()

    return () => {
      // this now gets called when the component unmounts
    }
  }, [selectedoffer])

  const sendNegotiate = async (value) => {
    let payload ={
      "expectedSalary": value?.salary,

    }
    let name = stdData?.admin?.first_name + ' ' + stdData?.admin?.last_name
      const final = corporateEmailList?.list?.map(item => {
        const template = offerNegotiateTemplate?.templateText
          ?.replace('{corporateName}', selectedoffer?.role?.corporate?.name)
          ?.replace('{studentName}', name)
          ?.replace('{roleName}', selectedoffer?.role?.tittle)
          ?.replace('{amount}', value?.salary)
        return {
          to: item?.email,
          subject:
          offerNegotiateTemplate?.subject,
          htmlBody: template,
        }
      })
     
    let responce = await dispatch(OfferNegotiate(selectedoffer?.roleId,selectedoffer?.driveId,payload))
    if (responce?.status >= 200 && responce?.status <= 300) {
      sendNotificationBulkEmail(final)
      updateDataCall()
     setDrawerSuccess(true)
     setDrawerNegotiate(false)
     dispatch(getAppliedRoleMetrics())
    }
  }

  const content = () => {
    return (
      <>
        <DetailHeader>Salary Offered by the Corporate</DetailHeader>
        <RightText>{`₹ ${formatNumber(selectedoffer?.salary)} ${
          selectedoffer.frequecy === 'ANNUALLY' ? ` per annum` : ` per month`
        }`}</RightText>
        <br></br>
        <Form
          style={{ width: '100%' }}
          scrollToFirstError
          onFinish={sendNegotiate}
          id={'negotiateForm'}
          layout="vertical"
        >
          <DetailHeader>Expected Salary</DetailHeader>
          <br></br>
          <Control>
            <StyledSelectDiv>
              <AntdSelect
                id="changeNum"
                width="100%"
                value="₹"
                bordered={false}
                placeholder="₹"
                disabled={true}
              />
            </StyledSelectDiv>
            <StyledInputDiv>
              <TierInputNumber
                height="80px"
                width="100%"
                name={'salary'}
                rules={[
                  {
                    required: true,
                    message: 'Please Enter Expected Salary!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value) {
                       
                        if (
                          Number(value) <= Number(selectedoffer?.salary)
                        ) {
                          return Promise.reject(
                            new Error(
                              `Must be more than ${selectedoffer?.salary}`
                            )
                          )
                        }
                      }
                      return Promise.resolve()
                    },
                  }),
                  
                ]}
                placeholder="Eg: 1,00,000"
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={value => value.replace(/\$\s?|(,*)/g, '')}
              />
            </StyledInputDiv>
          </Control>
        </Form>
      </>
    )
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.DangerStyle
          text="Cancel"
          onClick={() => {
            setDrawer(false)
          }}
        />
        <Button.Primary
          htmlType="submit"
          form={'negotiateForm'}
          text={'Send'}
        />
      </FooterFlex>
    )
  }
  return (
    
      <StyledDrawer
        width="600px"
        title={'Negotiation'}
        placement="right"
        closable={true}
        onClose={() => setDrawerNegotiate(false)}
        visible={drawer}
        content={content()}
        footer={footer()}
      />
    
  )
}

export default NegotiateOfferDrawer
